import axios from 'axios';
import axiosRetry, { exponentialDelay, isNetworkOrIdempotentRequestError } from 'axios-retry';
import { createGlovoClient } from './create-glovo-client';
import { cleanConfig, validateConfig } from './utils';
export const getFetcher = (rawConfig = { useGlovoApiError: false }) => {
    validateConfig(rawConfig);
    const config = cleanConfig(rawConfig);
    const client = createGlovoClient(axios, config);
    const { retries = 0, retryDelay = exponentialDelay, retryCondition = isNetworkOrIdempotentRequestError, onRetry = null, } = config.retriesConfig ?? {};
    if (config.retriesConfig) {
        axiosRetry(client, { retries, retryDelay, retryCondition, ...(onRetry ? { onRetry } : {}) });
    }
    return client;
};
//# sourceMappingURL=get-fetcher.js.map